// extracted by mini-css-extract-plugin
module.exports = {"ratingStar":"Rating__ratingStar","ratingStarHover":"Rating__ratingStarHover","filledStar":"Rating__filledStar","emptyStar":"Rating__emptyStar"};